<ion-header class="ion-no-border">
  <ion-toolbar mode="md">
    <ion-title>{{ 'Reader Location Setup' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()" fill="clear">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<div class="inner-content">
  <ng-container *ngIf="!createNew">
    <ion-list class="bg-light">
      <ion-radio-group [(ngModel)]="locationId"> 
        <ion-list-header>
          <ion-label>{{ 'Select Location' | translate }}</ion-label>
        </ion-list-header>
        <ion-item *ngFor="let location of locationList">
          <ion-label>{{location.displayName}} &nbsp;<small>({{location.locationId}})</small></ion-label>
          <ion-radio slot="start" [value]="location.locationId"></ion-radio>
        </ion-item>
      </ion-radio-group>
    </ion-list>
  </ng-container>

  <ng-container *ngIf="createNew">
    <form [formGroup]="locationForm">
      <ion-list class="bg-light">
        <ion-list-header>
          <ion-label>{{ 'Create New Location' | translate }}</ion-label>
        </ion-list-header>
        <ion-item>
          <ion-label position="stacked">{{ 'Display Name' | translate }}</ion-label>
          <ion-input [placeholder]="'Ex. mexico location' | translate" formControlName="displayName" required></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">{{ 'Country' | translate }}</ion-label>
          <ion-input [placeholder]="'Ex. US' | translate" formControlName="country" required></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">{{ 'State' | translate }}</ion-label>
          <ion-input [placeholder]="'Ex. Las Cruces' | translate" formControlName="state" required></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">{{ 'City' | translate }}</ion-label>
          <ion-input [placeholder]="'Ex. new mexico' | translate" formControlName="city" required></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">{{ 'Postal Code' | translate }}</ion-label>
          <ion-input [placeholder]="'Ex. 880001' | translate" formControlName="postalCode" required></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">{{ 'Address' | translate }}</ion-label>
          <ion-input formControlName="address" required></ion-input>
        </ion-item>
      </ion-list>
    </form>
  </ng-container>

</div>
<ion-footer class="px-3 py-2">
  <ion-grid>
    <ion-row *ngIf="!createNew">
    
      <ion-col>
        <ion-button fill="solid" expand="block" [disabled]="!locationId" (click)="save()">{{ 'Save' | translate }}</ion-button>
      </ion-col>
      <ion-col>
        <ion-button fill="outline" expand="block" color="secondary" (click)="createNew = true;">{{ '+ Add New' | translate }}</ion-button>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="createNew">
      <ion-col>
        <ion-button fill="outline" expand="block" color="secondary" (click)="createNew = false;">{{ 'Back' | translate }}</ion-button>
      </ion-col>
      <ion-col>
        <ion-button fill="solid" expand="block" [disabled]="locationForm.invalid" (click)="onCreateLocation()">{{ 'Create' | translate }}</ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>